import { render, staticRenderFns } from "./_expenses.vue?vue&type=template&id=9ddc0a0c&scoped=true&"
import script from "./_expenses.vue?vue&type=script&lang=js&"
export * from "./_expenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddc0a0c",
  null
  
)

export default component.exports